<template>
  <div id="onetrust-consent-sdk" v-show="showCookiesBanner">


    <div class="setting-popup" v-show="settingPopup">
      <div class="bg">

        <div class="head-line">
          <div class="logo-wrapper">
            <img :src="cookiesLogoSrc" alt="INCH.Health">
          </div>
          <div class="title">{{ $t('cookies.secondPopup.title') }}</div>
        </div>

        <div class="content">

          <div class="tab-list ">
            <div v-bind:class="[{ active:showTab === 1 }]" @click="showTab = 1" class="tab-item cursor-hover">
              <div class="show" v-bind:class="[{ hideMobile:showTab === 1 }]">
                {{ $t('cookies.secondPopup.text1') }}
              </div>

              <div class="tab-content mobile hide">
                <div v-show="showTab === 1" class="item">
                  <div class="line">
                    <div class="title">{{ $t('cookies.secondPopup.performance-title') }}</div>
                  </div>
                  <div class="main-text">
                    {{ $t('cookies.secondPopup.text-privacy') }}
                  </div>
                </div>

              </div>


            </div>
            <div v-bind:class="[{ active:showTab === 2 }]" @click="showTab = 2" class="tab-item cursor-hover">
              <div class="show" v-bind:class="[{ hideMobile:showTab === 2 }]">
                {{ $t('cookies.secondPopup.strictly-title') }}
              </div>
              <div class="tab-content mobile">
                <div v-show="showTab === 2" class="item">
                  <div class="line">
                    <div class="title">{{ $t('cookies.secondPopup.strictly-title') }}</div>
                    <div class="active-text">{{ $t('cookies.secondPopup.active-text') }}</div>
                  </div>
                  <div class="main-text">{{ $t('cookies.secondPopup.strictly-text') }}</div>
                </div>

              </div>

            </div>
            <div v-bind:class="[{ active:showTab === 3 }]" @click="showTab = 3" class="tab-item cursor-hover">
              <div class="show" v-bind:class="[{ hideMobile:showTab === 3 }]">
                {{ $t('cookies.secondPopup.targeting-title') }}
              </div>
              <div class="tab-content mobile">
                <div v-show="showTab === 3" class="item">
                  <div class="line">
                    <div class="title">{{ $t('cookies.secondPopup.targeting-title') }}</div>
                    <label class="switch cursor-hover">
                      <input v-model="targetCookies" :value="true" type="checkbox">
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="main-text">{{ $t('cookies.secondPopup.targeting-text') }}</div>
                </div>

              </div>

            </div>
            <div v-bind:class="[{ active:showTab === 4 }]" @click="showTab = 4" class="tab-item cursor-hover">
              <div class="show" v-bind:class="[{ hideMobile:showTab === 4 }]">
                {{ $t('cookies.secondPopup.functional-title') }}
              </div>
              <div class="tab-content mobile">
                <div v-show="showTab === 4" class="item">
                  <div class="line">
                    <div class="title">{{ $t('cookies.secondPopup.functional-title') }}</div>
                    <label class="switch cursor-hover">
                      <input v-model="functionalCookies" :value="true" type="checkbox">
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="main-text">{{ $t('cookies.secondPopup.functional-text') }}</div>
                </div>

              </div>

            </div>
            <div v-bind:class="[{ active:showTab === 5 }]" @click="showTab = 5" class="tab-item cursor-hover">
              <div class="show" v-bind:class="[{ hideMobile:showTab === 5}]">
                {{ $t('cookies.secondPopup.performance-title') }}
              </div>
              <div class="tab-content mobile">
                <div v-show="showTab === 5" class="item">
                  <div class="line">
                    <div class="title">{{ $t('cookies.secondPopup.performance-title') }}</div>
                    <label class="switch cursor-hover">
                      <input v-model="operationalCookies" :value="true" type="checkbox">
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="main-text">{{ $t('cookies.secondPopup.performance-text') }}</div>
                </div>

              </div>
            </div>
          </div>

          <div class="tab-content">
            <div v-show="showTab === 1" class="item">
              <div class="line">
                <div class="title">{{ $t('cookies.secondPopup.text1') }}</div>
              </div>
              <div class="main-text">
                {{ $t('cookies.secondPopup.text-privacy') }}
              </div>
            </div>
            <div v-show="showTab === 2" class="item">
              <div class="line">
                <div class="title">{{ $t('cookies.secondPopup.strictly-title') }}</div>
                <div class="active-text">{{ $t('cookies.secondPopup.active-text') }}</div>
              </div>
              <div class="main-text">{{ $t('cookies.secondPopup.strictly-text') }}</div>
            </div>
            <div v-show="showTab === 3" class="item">
              <div class="line">
                <div class="title">{{ $t('cookies.secondPopup.targeting-title') }}</div>
                <label class="switch ">
                  <input v-model="targetCookies" :value="true" type="checkbox">
                  <span class="slider round cursor-hover"></span>
                </label>
              </div>
              <div class="main-text">{{ $t('cookies.secondPopup.targeting-text') }}</div>
            </div>
            <div v-show="showTab === 4" class="item">
              <div class="line">
                <div class="title">{{ $t('cookies.secondPopup.functional-title') }}</div>
                <label class="switch ">
                  <input v-model="functionalCookies" :value="true" type="checkbox">
                  <span class="cursor-hover slider round"></span>
                </label>
              </div>
              <div class="main-text">{{ $t('cookies.secondPopup.functional-text') }}</div>
            </div>
            <div v-show="showTab === 5" class="item">
              <div class="line">
                <div class="title">{{ $t('cookies.secondPopup.performance-title') }}</div>
                <label class="switch ">
                  <input v-model="operationalCookies" :value="true" type="checkbox">
                  <span class="slider round cursor-hover"></span>
                </label>
              </div>
              <div class="main-text">{{ $t('cookies.secondPopup.performance-text') }}</div>
            </div>
          </div>

        </div>

        <div class="btn-wrapper">
          <div @click="accept" class="confirm-btn cursor-hover">
            <span>{{ $t('cookies.secondPopup.confirm-btn') }}</span>
          </div>

          <div @click="acceptAll" class="alloy-all cursor-hover">{{ $t('cookies.secondPopup.alloy-all') }}</div>
        </div>

      </div>
    </div>

    <div class="bottom-popup" v-show="firstPopup">

      <div class="bg">
        <div class="tittle">{{ $t('cookies.title') }}
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99933 9C6.26455 9 6.5189 8.89464 6.70644 8.70711C6.89398 8.51957 6.99933 8.26522 6.99933 8C6.99933 7.73478 6.89398 7.48043 6.70644 7.29289C6.5189 7.10536 6.26455 7 5.99933 7C5.73412 7 5.47976 7.10536 5.29223 7.29289C5.10469 7.48043 4.99933 7.73478 4.99933 8C4.99933 8.26522 5.10469 8.51957 5.29223 8.70711C5.47976 8.89464 5.73412 9 5.99933 9ZM9.99933 11C10.2646 11 10.5189 10.8946 10.7064 10.7071C10.894 10.5196 10.9993 10.2652 10.9993 10C10.9993 9.73478 10.894 9.48043 10.7064 9.29289C10.5189 9.10536 10.2646 9 9.99933 9C9.73412 9 9.47976 9.10536 9.29223 9.29289C9.10469 9.48043 8.99933 9.73478 8.99933 10C8.99933 10.2652 9.10469 10.5196 9.29223 10.7071C9.47976 10.8946 9.73412 11 9.99933 11ZM12.9993 14C12.9993 14.2652 12.894 14.5196 12.7064 14.7071C12.5189 14.8946 12.2646 15 11.9993 15C11.7341 15 11.4798 14.8946 11.2922 14.7071C11.1047 14.5196 10.9993 14.2652 10.9993 14C10.9993 13.7348 11.1047 13.4804 11.2922 13.2929C11.4798 13.1054 11.7341 13 11.9993 13C12.2646 13 12.5189 13.1054 12.7064 13.2929C12.894 13.4804 12.9993 13.7348 12.9993 14ZM6.99933 14C7.26455 14 7.5189 13.8946 7.70644 13.7071C7.89398 13.5196 7.99933 13.2652 7.99933 13C7.99933 12.7348 7.89398 12.4804 7.70644 12.2929C7.5189 12.1054 7.26455 12 6.99933 12C6.73412 12 6.47976 12.1054 6.29223 12.2929C6.10469 12.4804 5.99933 12.7348 5.99933 13C5.99933 13.2652 6.10469 13.5196 6.29223 13.7071C6.47976 13.8946 6.73412 14 6.99933 14ZM9.99933 2C8.3554 2.00014 6.75143 2.50672 5.40563 3.45082C4.05983 4.39493 3.03755 5.73071 2.47789 7.27644C1.91822 8.82217 1.84833 10.5028 2.27774 12.0897C2.70714 13.6765 3.61499 15.0926 4.87776 16.1451C6.14053 17.1977 7.69691 17.8357 9.33516 17.9723C10.9734 18.1089 12.614 17.7376 14.0336 16.9087C15.4533 16.0798 16.5832 14.8337 17.2695 13.3399C17.9558 11.8461 18.1652 10.1771 17.8693 8.56C17.8524 8.4677 17.8097 8.38204 17.7464 8.31281C17.683 8.24359 17.6014 8.1936 17.511 8.16856C17.4205 8.14352 17.3249 8.14445 17.2349 8.17123C17.145 8.19801 17.0644 8.24957 17.0023 8.32C16.734 8.62562 16.3789 8.84218 15.9844 8.94082C15.5899 9.03945 15.1747 9.01547 14.7941 8.87207C14.4135 8.72867 14.0858 8.47267 13.8544 8.13819C13.6231 7.80372 13.4992 7.40668 13.4993 7C13.4992 6.87225 13.4555 6.74836 13.3756 6.64874C13.2956 6.54913 13.184 6.47973 13.0593 6.452C12.7077 6.37284 12.384 6.20014 12.1225 5.95215C11.861 5.70417 11.6713 5.39013 11.5736 5.04322C11.4758 4.69632 11.4736 4.32945 11.5672 3.9814C11.6609 3.63336 11.8468 3.31708 12.1053 3.066C12.1696 3.00363 12.2159 2.92515 12.2394 2.83876C12.263 2.75237 12.2629 2.66125 12.2392 2.5749C12.2155 2.48856 12.169 2.41017 12.1047 2.34791C12.0403 2.28566 11.9604 2.24183 11.8733 2.221C11.2595 2.07385 10.6305 1.99967 9.99933 2ZM2.99933 10C2.99928 9.00718 3.21042 8.0257 3.61873 7.12073C4.02705 6.21576 4.6232 5.40799 5.36761 4.75107C6.11202 4.09414 6.98765 3.60308 7.93638 3.31049C8.88511 3.0179 9.88523 2.93047 10.8703 3.054C10.6596 3.43678 10.535 3.86098 10.5053 4.29694C10.4756 4.73289 10.5414 5.17007 10.6983 5.57791C10.8552 5.98575 11.0993 6.35439 11.4134 6.65807C11.7276 6.96174 12.1044 7.19311 12.5173 7.336C12.5728 7.83007 12.7503 8.3026 13.0337 8.7111C13.3171 9.1196 13.6976 9.45126 14.1409 9.67625C14.5843 9.90125 15.0766 10.0125 15.5736 10.0001C16.0706 9.98766 16.5568 9.85189 16.9883 9.605C17.0408 10.5392 16.9054 11.4744 16.5902 12.3554C16.275 13.2363 15.7864 14.0452 15.1532 14.7341C14.5201 15.423 13.7553 15.9779 12.904 16.3662C12.0527 16.7544 11.1322 16.9681 10.1969 16.9945C9.26163 17.0209 8.33055 16.8595 7.4587 16.5199C6.58685 16.1803 5.79193 15.6694 5.12092 15.0173C4.44991 14.3653 3.91644 13.5853 3.55204 12.7235C3.18764 11.8617 2.9997 10.9357 2.99933 10Z"
              fill="black"/>
          </svg>
        </div>
        <div class="text">
          {{ $t('cookies.firstPopup.text') }} <span class="link cursor-hover" @click="settingCookies" v-html="$t('cookies.firstPopup.link')"></span>
        </div>
        <div class="btn-wrapper">

          <button class="type1 cursor-hover" @click="rejectAll">
            <span>{{ $t('cookies.firstPopup.btn2') }}</span>
          </button>

          <button class="type2 cursor-hover" @click="acceptAll">
            {{ $t('cookies.firstPopup.btn3') }}
          </button>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      showCookiesBanner: true,
      targetCookies: false,
      functionalCookies: false,
      operationalCookies: false,
      firstPopup: true,
      settingPopup: false,
      showTab: 1,
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentLangs',
      'getUserTheme',
    ]),
    cookiesLogoSrc() {
      return this.getUserTheme === 'dark-theme'
        ? require('@/assets/img/logo-cookies-dark-white.svg')
        : require('@/assets/img/logo-light-bg.svg');
    },
  },
  methods: {
    // start banner nav
    settingCookies() {
      this.settingPopup = true;
      this.firstPopup = false;
    },
    hideSetting() {
      this.settingPopup = false;
    },
    hideBanner() {
      this.hideSetting();
      this.showCookiesBanner = false;

      localStorage.setItem('cookies', this.showCookiesBanner);

    },
    // end banner nav
    setCookie(name, value, options = {}) {
      options = {
        path: "/",
        // при необходимости добавьте другие значения по умолчанию
        ...options,
      };

      if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
      }

      let updatedCookie =
        encodeURIComponent(name) + "=" + encodeURIComponent(value);

      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }

      document.cookie = updatedCookie;
    },
    getCookie(name) {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    deleteCookie(name) {
      this.setCookie(name, "", {
        "max-age": -1,
      });
    },
    cookiesDelete() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;";
        document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    },

    acceptAll() {
      this.hideSetting();

      this.targetCookies = true;
      this.functionalCookies = true;
      this.operationalCookies = true;

      this.hideBanner();
      this.acceptCookies();
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)

    },
    rejectAll() {
      this.hideSetting();

      this.targetCookies = false;
      this.functionalCookies = false;
      this.operationalCookies = false;

      this.hideBanner();
      this.acceptCookies();
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)


    },
    accept() {
      this.hideBanner();
      this.acceptCookies();

      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)

    },
    acceptCookies() {
      this.cookiesDelete();


      let expires = new Date(new Date().valueOf() + 30000 * 60 * 60 * 24 * 15);
      document.cookie = "inch-targetCookies=" + this.targetCookies + "; expires=" + expires;
      document.cookie = "inch-functionalCookies=" + this.functionalCookies + "; expires=" + expires;
      document.cookie = "inch-operationalCookies=" + this.operationalCookies + "; expires=" + expires;

      if (!this.showCookiesBanner) {
        let expires = new Date(new Date().valueOf() + 30000 * 60 * 60 * 24 * 15);
        document.cookie = "inch-scb=false; expires=" + expires;
      }

      if (this.targetCookies) {
        // FB
      } else {

      }

      if (this.functionalCookies) {
        // console.log("functionalCookies");
      }

      if (this.operationalCookies) {
        // console.log("operationalCookies");
        // аналитике Гугла, Тег менеджера Гугла и Хотжар.

        //<!-- Google Tag Manager -->
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"});
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
          j.async = true;
          j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-W8MJJPF");
        //<!-- End Google Tag Manager -->

        // <!-- Global site tag (gtag.js) - Google Analytics -->
        (function () {
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag("js", new Date());

          gtag("config", "G-RW2EDZGXBN");
        })();


        // <!-- Hotjar Tracking Code for https://sleep.inch.ua/ -->
        (function (h, o, t, j, a, r) {
          h.hj =
            h.hj ||
            function () {
              (h.hj.q = h.hj.q || []).push(arguments);
            };
          h._hjSettings = {hjid: 1829902, hjsv: 6};
          a = o.getElementsByTagName("head")[0];
          r = o.createElement("script");
          r.async = 1;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");


      } else {
        // delete window.dataLayer;
        // window.gtag = function(){
        //   // stub function
        // }
        const cyrb53 = function (str, seed = 0) {
          let h1 = 0xdeadbeef ^ seed,
            h2 = 0x41c6ce57 ^ seed;
          for (let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
          }
          h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
          h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
          return 4294967296 * (2097151 & h2) + (h1 >>> 0);
        };

        let clientIP = fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ip}) => {
            return ip;
          });
        ;
        let validityInterval = Math.round(new Date() / 1000 / 3600 / 24 / 4);
        let clientIDSource = clientIP + ";" + window.location.host + ";" + navigator.userAgent + ";" + navigator.language + ";" + validityInterval;
        let clientIDHashed = cyrb53(clientIDSource).toString(16);

        window.dataLayer = window.dataLayer || [];

        gtag('js', new Date());

        gtag('config', 'G-RW2EDZGXBN', {client_storage: 'none', anonymize_ip: true, client_id: clientIDHashed});

      }
    }

  },
  mounted() {
    // console.log(localStorage.getItem('cookies'))
    if (localStorage.getItem('cookies') !== null) {
      this.showCookiesBanner = false
    }
    if (this.showCookiesBanner) {
      this.showCookiesBanner = this.getCookie("inch-scb") !== "false" ? true : false;

      this.targetCookies = this.getCookie('inch-targetCookies') === "true" ? true : false;
      this.functionalCookies = this.getCookie('inch-functionalCookies') === "true" ? true : false;
      this.operationalCookies = this.getCookie('inch-operationalCookies') === "true" ? true : false;

      this.acceptCookies();

    }

  },
};
</script>

<style scoped lang="scss" id="onetrust-style">
* {
  font-family: "Montserrat";
}

.bottom-popup {
  position: fixed;
  left: 0;
  right: 0;

  bottom: 40px;
  margin: 0 20px;

  .bg {
    max-width: 730px;
    width: 100%;

    margin: 0 auto;

    background: var(--cookeis-bg);

    border: 1px solid #92A1AE;

    display: flex;
    flex-direction: column;
    padding: 20px 32px;

    @media screen and (max-width: 600px) {
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    > button {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      display: inline-block;
      padding: 14px 30px;

      color: var(--text-primary-color-case);

      &.type1 {
        @media screen and (min-width: 1023px) {
          span {
            &:hover {
              background-size: 0 1px, 10% 1px;
            }
          }
        }

        &:active {
          span {
            background-size: 0 1px, 10% 1px;

          }
        }

        span {
          position: relative;
          display: inline;

          -webkit-tap-highlight-color: transparent;

          text-decoration: none;
            background: linear-gradient(to right, var(--footer-text-color), var(--footer-text-color)),
          linear-gradient(to right, var(--footer-text-color), var(--footer-text-color));
          background-size: 0 1px, 100% 1px;

          background-position: 100% 100%, 0 100%;
          background-repeat: no-repeat;
          transition: background-size 400ms;
        }
      }

      &.type2 {
        border: 1px solid var(--text-primary-color-case);

        &:active {
          background: #29F6D9;
          border-color: #29F6D9;
          color: #000000;
        }
      }
    }
  }

  .text {
    text-align: left;
    color: var(--cookeis-color-text);
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;


    .link {
      color: var(--text-primary-color-case);
      position: relative;

      @media screen and (min-width: 1023px) {
        &:hover {
          &:before {
            width: 10%;
          }
        }
      }

      &:active {
        &:hover {
          &:before {
            width: 10%;
          }
        }
      }

      &:before {
        content: '';

        width: 100%;
        height: 1px;

        position: absolute;
        left: 0;
        bottom: 0;

        background: var(--text-primary-color-case);

        transition: width .2s ease;
      }
    }
  }

  .tittle {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    text-align: left;
    display: flex;
    align-items: center;
    color: var(--text-primary-color-case);

    svg {
      display: block;
      margin-left: 7px;

      path {
        fill: var(--text-primary-color-case);
      }
    }
  }
}

.setting-popup {
  position: fixed;
  left: 0;
  right: 0;

  bottom: 40px;
  margin: 0 20px;

  .bg {
    max-width: 920px;
    width: 100%;

    margin: 0 auto;

    background: var(--cookeis-bg);

    border: 1px solid #92A1AE;

    display: flex;
    flex-direction: column;
    position: relative;

  }

  .head-line {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding: 25px 30px;
    border-bottom: 1px solid #92A1AE;

    @media screen and (max-width: 640px) {
      justify-content: space-between;

    }


    .title {
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      padding-left: 40px;
      text-align: left;

      @media screen and (max-width: 640px) {
        padding-left: 0;
        text-align: right;
      }
      color: var(--text-primary-color-case);
    }

    .logo-wrapper {
      max-width: 136px;
      width: 100%;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      @media screen and (max-width: 768px) {
        max-width: 120px;
      }


      @media screen and (max-width: 768px) {
        max-width: 82px;
      }

      img,
      svg {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }

  .content {
    display: flex;
    border-bottom: 1px solid #92A1AE;
    z-index: 40;

    .tab-list {
      max-width: 270px;
      width: 100%;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 768px) {
        max-width: 240px;
      }

      .tab-item {
        position: relative;
        padding: 26px 30px;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.08em;
        color: var(--text-primary-color-case);
        text-align: left;
        border-bottom: 1px solid #92A1AE;
        border-right: 1px solid #92A1AE;

        .show {
          font-weight: 600;
          text-transform: uppercase;
        }

        &:last-child {
          border-bottom: none;
        }

        &.active {
          color: #92A1AE;
          position: relative;
          border-right-color: rgba(0, 0, 0, 0);

          &:before {
            content: '';
            background: #29F6D9;
            position: absolute;

            left: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            width: 10px;
          }
        }
      }
    }

    .tab-content {
      max-width: 70%;
      width: 100%;

      display: flex;
      flex-direction: column;

      &.mobile {
        display: none;
      }

      .item {
        padding: 20px 40px;

        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title {
            text-align: left;
            color: var(--menu-icon-color);
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
          }

          .active-text {

            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: #29F6D9;

          }

          .switch {
            position: relative;
            display: inline-block;
            width: 52px;
            height: 30px;
          }

          .switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            -webkit-transition: .4s;
            transition: .4s;
            border: 1px solid var(--menu-icon-color);

          }

          .slider:before {
            position: absolute;
            content: "";
            height: 24px;
            width: 24px;
            left: 1px;
            bottom: 1px;
            -webkit-transition: .4s;
            transition: .4s;
            background: #E9ECEF;
            border: 1px solid var(--menu-icon-color);

          }


          input:checked + .slider:before {
            transform: translateX(22px);
            background: #29F6D9;
          }

          /* Rounded sliders */
          .slider.round {
            border-radius: 34px;
          }

          .slider.round:before {
            border-radius: 50%;
          }
        }

        .main-text {

          margin-top: 16px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: var(--cookeis-color-text-message);
          text-align: left;
        }
      }
    }
  }

  .btn-wrapper {
    display: flex;

    justify-content: flex-end;

    padding: 16px 40px;


    .confirm-btn {

      padding: 14px 30px;

      @media screen and (min-width: 1023px) {

        &:hover {
          span {
            &:before {
              width: 10%;
            }
          }
        }
      }

      &:active {
        span {
          color: #29F6D9;

          &:before {
            width: 10%;
            background: #29F6D9;
          }
        }
      }

      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--text-primary-color-case);

        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 1px;
          transition: width .2s ease;
          background: var(--text-primary-color-case);
        }
      }

    }

    .alloy-all {

      padding: 14px 30px;

      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: var(--text-primary-color-case);
      border: 1px solid var(--text-primary-color-case);

      &:active {
        color: #000000;
        background: #29F6D9;
        border-color: #29F6D9;
      }
    }
  }
}

@media screen and (max-width: 670px) {
  .setting-popup {

    top: 20px;
    height: calc(100% - 40px);

    .bg {
      height: 100%;
      overflow: auto;
    }

    .head-line {


      .title {
      }

      .logo-wrapper {

        svg {
        }
      }
    }

    .content {

      .tab-list {
        max-width: 100%;

        .tab-item {
          .show {
            &.hideMobile {
              display: none;
            }
          }
        }
      }

      .tab-content {
        display: none;
        max-width: 100%;
        width: 100%;

        &.mobile {
          display: block;
        }

        .item {
          padding: 0;

          .line {

            .title {
              text-align: left;
              color: var(--menu-icon-color);
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
            }

            .switch {
              position: relative;
              display: inline-block;
              width: calc(52px * .7);
              height: calc(30px * .7);
            }

            .slider:before {
              position: absolute;
              content: "";
              height: 15px;
              width: 15px;
              left: 1px;
              bottom: 1px;
              -webkit-transition: .4s;
              transition: .4s;
              background: #E9ECEF;
              border: 1px solid var(--menu-icon-color);

            }

            input:checked + .slider:before {
              transform: translateX(15px);
            }

          }
        }
      }
    }

    .btn-wrapper {
      margin-top: 0;
      margin-bottom: 0;
      flex-direction: column;
      padding: 20px;

      .confirm-btn {
      }

      .alloy-all {

      }
    }
  }
}

@media screen and (max-width: 600px) {
  .bottom-popup {
    bottom: 10px;
    margin: 0 10px;

    .bg {
      padding: 15px;
    }

    .tittle {
      font-size: 16px;
      line-height: 28px;
    }

    .text {
      font-size: 12px;
    }

    .btn-wrapper {

      > button {
        padding: 10px 15px;

        color: var(--text-primary-color-case);

      }
    }
  }
}

@media screen and (max-width: 550px) {
  .setting-popup {

    .bg {
    }

    .head-line {
      padding: 15px;
      justify-content: space-between;

      .title {
        font-size: 14px;
        text-align: right;
        line-height: 18px;
      }

      .logo-wrapper {

        svg {
        }
      }
    }

    .content {

      .tab-list {

        .tab-item {

          padding: 15px;

          &.active {

            &:before {
              width: 5px;
            }
          }
        }
      }

      .tab-content {

        .item {

          .main-text {
            font-size: 12px;
          }

          .line {

            .title {
              margin-right: 5px;
              font-size: 14px;
              line-height: 18px;

            }

            .active-text {
              font-size: 12px;
              text-align: right;
              line-height: 14px;
            }
          }
        }
      }
    }

    .btn-wrapper {
      padding-right: 15px;
      padding-left: 15px;
      margin-top: 0;

      .confirm-btn {
        span {
          font-size: 14px;
        }
      }

      .alloy-all {
        font-size: 14px;
        padding: 15px;
      }
    }
  }
}
</style>
